var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82051 5.7303L7.8205 1.31504C7.8205 0.258333 6.5429 -0.270864 5.79569 0.476339L1.11082 5.16121C0.647617 5.62441 0.647616 6.37542 1.11082 6.83862L5.79566 11.5235C6.54286 12.2707 7.82045 11.7415 7.82046 10.6848L7.82051 5.7303Z",
    fill: "#000348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTriangle);
export default __webpack_public_path__ + "static/media/LeftTriangle.be5700cdff494f8ceed2b90a92f0cde8.svg";
export { ForwardRef as ReactComponent };